<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :ok-disabled="disableSubmit"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">
    <emp-entrance-common-link-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></emp-entrance-common-link-form>
  </j-modal>
</template>

<script>

  import EmpEntranceCommonLinkForm from './EmpEntranceCommonLinkForm'
  export default {
    name: 'EmpEntranceCommonLinkModal',
    components: {
      EmpEntranceCommonLinkForm
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>